import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=6fcf07af&scoped=true"
import script from "./Funds.vue?vue&type=script&lang=js"
export * from "./Funds.vue?vue&type=script&lang=js"
import style0 from "./Funds.vue?vue&type=style&index=0&id=6fcf07af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcf07af",
  null
  
)

export default component.exports